import { render } from "./pharmacybreadcrumb2.vue?vue&type=template&id=bed9f588"
import script from "./pharmacybreadcrumb2.vue?vue&type=script&lang=js"
export * from "./pharmacybreadcrumb2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__